"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardBadgeList = void 0;
var react_1 = __importDefault(require("react"));
var Badges_1 = __importDefault(require("../Badge/Badges"));
var CardBadgeList = function (props) {
    var _a;
    if (!((_a = props.badges) === null || _a === void 0 ? void 0 : _a.length))
        return null;
    return (react_1.default.createElement("div", { className: props.className },
        react_1.default.createElement(Badges_1.default, null, props.badges)));
};
exports.CardBadgeList = CardBadgeList;
exports.default = exports.CardBadgeList;
